import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service';
import { messages } from './messages';

export const PackingSlipPrinted = {
  id: 'packingSlip',
  displayName: <FormattedMessage {...messages.packingSlipPrinted} />,
  type: OptionFormTypes.TYPE_BOOLEAN,
  filterValue: 'IsPackingSlipPrinted',

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_IS_RADIO_OPTIONS, criteriaInformations);
  },
};
